var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9966 9.54999L14.9966 2.99999C14.9966 2.46956 14.7859 1.96085 14.4108 1.58578C14.0357 1.2107 13.527 0.999988 12.9966 0.999988L5.28658 0.999988C4.62888 0.998096 3.98878 1.21239 3.46479 1.6099C2.94081 2.00741 2.56197 2.5661 2.38658 3.19999L1.08658 7.94999C0.988115 8.30747 0.97346 8.68285 1.04376 9.04691C1.11406 9.41098 1.26742 9.75392 1.4919 10.049C1.71639 10.3442 2.00594 10.5835 2.33803 10.7484C2.67012 10.9134 3.03579 10.9995 3.40658 11L7.99658 11L7.64658 15.26C7.62712 15.4816 7.65407 15.7048 7.72571 15.9154C7.79736 16.1259 7.91213 16.3193 8.06269 16.483C8.21324 16.6467 8.39629 16.7773 8.60014 16.8663C8.80398 16.9553 9.02415 17.0008 9.24658 17C9.48173 17.0003 9.71403 16.9484 9.92672 16.8481C10.1394 16.7478 10.3272 16.6016 10.4766 16.42L14.0666 12.11C14.6665 11.3917 14.9956 10.4858 14.9966 9.54999Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4966 9.75C18.4966 9.88807 18.6085 10 18.7466 10C18.8847 10 18.9966 9.88807 18.9966 9.75L18.9966 1.25C18.9966 1.11193 18.8847 1 18.7466 1C18.6085 1 18.4966 1.11193 18.4966 1.25L18.4966 9.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.5fde2c9c93b9803e00368215da5f0362.svg";
export { ForwardRef as ReactComponent };